import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from 'react-bootstrap/Form';
import user from "../assets/img/notification/user.svg";
import { useEffect, useState } from 'react';
import { deleteNotification, getUserNotifications } from '../services/apiOtherlink';
import moment from 'moment';
import { Link } from 'react-router-dom';

function Notification({ name, show, onClose, onCountUpdate, ...props }) {
  const [notifArr, setNotifArr] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const allSelected =
    notifArr.length > 0 && selectedIds.length === notifArr.length;
  useEffect(() => {
    getAllNotification()
  }, [])
  const getAllNotification = async () => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const formData = {
      userid: user._id,
      offset: 0,
      limit: 20
    }
    let allNotification = await getUserNotifications(formData);
    setNotifArr(allNotification.notifications)

  };

  // Toggle the master checkbox
  const handleSelectAll = e => {
    const { checked } = e.target;
    setSelectedIds(checked ? notifArr.map(n => n._id) : []);
  };

  // Toggle one row
  const handleRowSelect = id => e => {
    const { checked } = e.target;
    setSelectedIds(prev =>
      checked ? [...prev, id] : prev.filter(x => x !== id)
    );
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;

    await deleteNotification({
      notificationid: selectedIds,
    });

    setSelectedIds([]);
    getAllNotification();
    onCountUpdate();
  };


  return (
    <Offcanvas show={show} onHide={onClose} {...props}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Notifications</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="notificationright">
        {/* -------- top action row -------- */}
        <div className="mb-3 action-notifications post-btn-conatiner d-flex justify-content-between align-items-center">
          <Form>
            <Form.Check
              type="checkbox"
              id="select-all"
              label="Select all"
              checked={allSelected}
              onChange={handleSelectAll}
            />
          </Form>

          <button
            className="btn btn-primary not-delete"
            onClick={handleDelete}
            disabled={!selectedIds.length}
          >
            Delete
          </button>
        </div>

        {/* -------- list -------- */}
        <ul className="notification-list-wrap">
          {notifArr.map((notification) => (
            <li key={notification._id} className="d-flex align-items-start">
              <Form className="me-2">
                <Form.Check
                  type="checkbox"
                  id={`notif-${notification._id}`}
                  checked={selectedIds.includes(notification._id)}
                  onChange={handleRowSelect(notification._id)}
                />
              </Form>

              <div className="notification-list d-flex">
                <img
                  src={user}
                  alt="avatar"
                  className="create-post-avtar me-2"
                />

                <div className="notification-detilas">
                  {notification.postId ?
                    <p className="mb-1">
                      <Link className='notification-link'
                        to="/post"
                        state={{ PostId: notification.postId }}
                        onClick={() => onClose()}
                      >
                        {notification.message}
                      </Link>
                    </p>
                    :
                    <p className="mb-1">
                      {notification.message} </p>
                  }
                  <span className="time-n">
                    {moment(notification.createdAt).format("MM/DD/YYYY")}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Notification;
